/**
 * Steam 分版本分析页 — 常量定义
 * @description 页面级常量，仅用于 VersionAnalysis List 页面
 */
import type { IVersionConfig } from '../../config';

/**
 * 筛选器默认日期范围（天）
 * @description 默认显示最近 7 天的数据
 */
export const DEFAULT_DATE_RANGE_DAYS = 7;

/**
 * 页面名称常量
 * @description 用于筛选器系统注册
 */
export const PAGE_NAME_VERSION_ANALYSIS = 'SteamPerformance_VersionAnalysis';

/** 显示列的默认可见列 */
export const DEFAULT_VISIBLE_COLUMNS = [
  'rating',
  'number_of_reviews',
  'positive_reviews',
  'positive_ratio',
  'negative_reviews',
  'negative_ratio',
];

/**
 * 图表指标类型
 * @description 版本对比图表支持的指标维度
 */
export const CHART_METRIC_TYPES = {
  /** 评论数 */
  REVIEWS: 'total_reviews',
  /** 推荐数 */
  POSITIVE_REVIEWS: 'positive_reviews',
  /** 推荐率 */
  POSITIVE_RATIO: 'positive_ratio',
} as const;

/**
 * 图表默认指标
 * @description 图表默认显示的指标
 */
export const DEFAULT_CHART_METRIC = CHART_METRIC_TYPES.POSITIVE_RATIO;

/**
 * 图表指标选项（含占比标记）
 * @description 版本对比图表支持的指标选项，组件和下载共用
 */
export const CHART_METRIC_OPTIONS = [
  { text: 'Number of Reviews', value: 'reviews', isPercent: false },
  { text: 'Positive Reviews', value: 'pos_reviews', isPercent: false },
  { text: 'Positive Ratio', value: 'pos_ratio', isPercent: true },
  { text: 'Negative Reviews', value: 'neg_reviews', isPercent: false },
  { text: 'Negative Ratio', value: 'neg_ratio', isPercent: true },
] as const;

/**
 * 配置游戏视图选项
 * @description 配置游戏支持的视图维度（从 versionConfig.levels 动态生成）
 */
export const buildViewOptions = (
  config: IVersionConfig | null,
) =>
  config?.levels?.map(level => ({
    text: `By ${level.label}`,
    value: level.value,
  })) ?? [];
